/**
 * The address to say out loud — this installation's host, as a person would type it.
 *
 * Read from where the browser actually IS rather than hardcoded, because a TV on the LAN
 * is looking at an IP and a port. Telling that operator to open "goonlords.com" on their
 * phone would send them to a DIFFERENT installation, with a different database, where the
 * code they are squinting at does not exist — and it would look like the code was wrong
 * rather than like the instruction was.
 *
 * Three surfaces print it: the screen showing a code says where to type it, and both code
 * boxes say where to get one. They have to agree, so it lives here rather than three
 * times.
 */
export function hostLabel(): string {
  if (typeof window === "undefined") return "this site";
  // `host`, not `hostname`: a dev server and a LAN box are only reachable WITH the port,
  // and dropping it produces an address that looks right and does not resolve.
  return window.location.host.replace(/^www\./, "");
}
